import React, { Component } from 'react';
import StepBar from 'components/StepBar';
import './index.less';

export default class CardFooter extends Component {
    constructor(props){
        super(props);
        this.state = {
            count : 0 ,
            status: true,
            stepData : [
                {
                    title : '签到',
                    iconName : "iconProcess",
                },
                {
                    title : '排队',
                    iconName : "iconWait",
                },
                {
                    title : '出厂',
                    iconName : "iconWait",
                }
            ]
        }
    }

    componentDidMount(){
        this.changeStep();
    }

    changeStep = () => {
        const { currentStatusCode } = this.props;
        const { stepData } = this.state;
        let count;
        stepData.map((item,index) => {
            switch( currentStatusCode ){
                case "1" :
                    count = 1;
                    index === 0 && (item.iconName = 'iconFinshed')
                    index === 1 && (item.iconName = 'iconProcess')
                    break;
                case "2" :
                    count = 2;
                    index === 0 && (item.iconName = 'iconFinshed')
                    index === 1 && (item.iconName = 'iconFinshed')
                    index === 2 && (item.iconName = 'iconProcess')
                    break;
                default :
                    break;
            }
        })
        this.setState({
            count,
            stepData
        })
    }
    

    render() {
        return (
            <div className="card-footer">
                <StepBar {...this.state}></StepBar>
            </div>
        )
    }
}
